import { Ref } from 'react'
import { IMaskMixin } from 'react-imask'

const AutoNumberInputMasked = IMaskMixin(({ inputRef, ...inputProps }) => (
  <input {...inputProps} ref={inputRef as Ref<HTMLInputElement>} />
))

export { AutoNumberInputMasked }
